import styled from "styled-components"

const Footer = styled.div`
    width:100%;
    display:flex;
    height:270px;
    color:white;
    background-color:#214142;
    justify-content:center;
    align-items:center;
    text-align:center;
    .logo{
        width:80vw;
        margin:0 0 10px 0;
        padding-top:70px;
        border-top:2px solid #021717;
    }
    .description{
        font-size:0.8em;
    }
`
export default Footer